import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import Button from "@/components/button";
import "react-datetime/css/react-datetime.css";
import { Form, Formik, FormikControl, useTranslation, Exclamation } from "@/imports-files/common/common";
import {
  UNSUCCESSFUL_REASON_INITIAL_VALUES,
  InputError,
  InputText,
  ComponentStyle,
  UnsuccessfulModalValidation,
} from "@/imports-files/components/add-to-job-modal.js";
import {
  markActiveUnsuccessful,
  getReasonsList,
  useRouter,
  useState,
  components,
  useEffect,
  useSWR,
  clearSWRCache,
} from "@/imports-files/pages/clients/candidates/kanban";
import Tooltip from "react-simple-tooltip";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";

export function UnsuccessfulModal(props) {
  const {t} = useTranslation()
  clearSWRCache("unsuccessful-reasons-list");
  const router = useRouter();
  const Placeholder = (props) => {
    return <components.Placeholder {...props} />;
  };
  const [reasons, setReasons] = useState([]);
  const { data, error } = useSWR("unsuccessful-reasons-list", () => {
    return getReasonsList("", router);
  });
  const [isLoading, setLoading] = useState(true);
  const [showOther, setShowOther] = useState(false);
  const [otherValidationCheck, setOtherValidationCheck] = useState(false);
  useEffect(() => {
    if (data) {
      setLoading(false);
      setReasons(data);
    }
  }, [data]);

  if (isLoading) {
    return "";
  }

  async function getSuggestions(router) {
    let reasons_list = await getReasonsList("", router);
    return reasons_list;
  }

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
        <div className={`${FormModalStyle.Modal__Container__Heading__Close}`}>
          <h1
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              {props?.texts?.heading || t('modal:unsuccessful_reasons:heading')}
            </h1>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => {
              props.setUnsuccessfulModal(false);
            }}
          >
            <Close />
          </div>
        </div>
          <div className={FormModalStyle.Modal__Container__ContentSection}>
            <Formik
              initialValues={
                props.formInitialValues || UNSUCCESSFUL_REASON_INITIAL_VALUES
              }
              validationSchema={
                props.formValidations || UnsuccessfulModalValidation(otherValidationCheck)
              }
              onSubmit={async (values) => {
                if (props.selectedCards) {
                  props.selectedCards.reason_text = values.reason_text;
                  props.selectedCards.reason_id = values.reason_id;
                  props.selectedCards.reason = values.reason_text;
                }
                props?.page_name ? "" : await markActiveUnsuccessful(props);
                if (props.submitFormAction) props.submitFormAction(values);
              }}
            >
              {(formik) => (
                <Form>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt30`}
                  >
                    <label
                      className={`${PageStyle.Form__FloatingLabel} ${PageStyle.Form__FloatingLabelWithIcon}`}
                    style={InputText(formik, "reason")}>
                     <span className={`red-color`}>*</span>&nbsp;{props?.texts?.label || t('modal:unsuccessful_reasons:reason')}&nbsp;&nbsp;
                     <Tooltip className='SimpleTooltip' content={t('placeholder:max_50_char')} background={'#00325A'} radius={20} padding={8} placement="right" fontSize="12px">
                        <p className={`tooltipwidthinterview200 m0`} ><Exclamation/></p>
                      </Tooltip>
                    </label>
                    {props.page_name == "unsuccessfulReasons" ? (
                      <FormikControl
                        control="input"
                        className={` ${FormModalStyle.Form__InputFullWidth} ${PageStyle.Form__Input}`}
                        errorClass={FormModalStyle.Form__Error}
                        formik={formik}
                        name="reason"
                        maxLength="50"
                        placeholder={props?.texts?.placeholder}
                        style={InputError(formik, "reason")}
                        type="text"
                      />
                    ) : (
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}
                      style={InputText(formik, "reason_id")}>
                        <FormikControl
                          className={`${FormModalStyle.Form__CustomSelect} ${PageStyle.Form__CustomSelect}`}
                          components={{ Placeholder }}
                          control="select"
                          default={formik.values.reason_id}
                          formik={formik}
                          name="reason_id"
                          onChange={(option) => {
                            formik.setFieldValue("reason_id", option.value);
                            formik.setFieldValue("reason", option.label);
                            if (option.reason == "Other") {
                              setOtherValidationCheck(true);
                              setShowOther(true);
                            } else {
                              setOtherValidationCheck(false)
                              setShowOther(false);
                              formik.setFieldValue("reason_text", "");
                            }
                          }}
                          options={reasons}
                          placeholder={ t('placeholder:select:please')}
                          style={InputError(formik, "reason_id")}
                          value={reasons?.filter(
                            (option) => option.value === formik.values.reason_id
                          )}
                        />
                      </div>
                    )}
                  </div>
                  <div className={`height113`}>
                    {showOther && (
                      <div className={`${PageStyle.Form__TableCol}`}>
                        <label className={`${PageStyle.Form__FloatingLabel} ${PageStyle.Form__FloatingLabelWithIcon}`}>
                        <span className={`red-color`}>*</span>&nbsp;{t('modal:unsuccessful_reasons:other_reason')}&nbsp;
                        <Tooltip className='SimpleTooltip' content={t('placeholder:max_50_char')} background={'#00325A'} radius={20} padding={8} placement="right" fontSize="12px">
                          <p className={`tooltipwidthinterview200 m0`} ><Exclamation/></p>
                        </Tooltip>
                        </label>
                        <FormikControl
                          control="input"
                          className={`${FormModalStyle.Form__Input}`}
                          errorClass={FormModalStyle.Form__Error}
                          formik={formik}
                          name="reason_text"
                          maxLength="50"
                          placeholder={""}
                          infoPlaceholder={t('placeholder:max_50_char')}
                          style={InputError(formik, "reason_text")}
                          type="text"
                        />
                      </div>
                    )}
                  </div>

                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button
                      buttonstyle={`${FormModalStyle.secondarybtn}`}
                      type="button"
                      onClick={() => {
                        props.setUnsuccessfulModal(false);
                      }}
                    >
                      {props?.texts?.button_1 || t('button:cancel')}
                    </Button>
                    <Button
                      buttonstyle={`${FormModalStyle.primarybtn}`}
                      type="submit"
                      disabled={props.disableSubmitButton}
                    >
                      {props?.texts?.button_2 || t('button:submit')}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
